import { render, staticRenderFns } from "./personal-data.vue?vue&type=template&id=81aa0f3a&scoped=true"
import script from "./personal-data.vue?vue&type=script&lang=js"
export * from "./personal-data.vue?vue&type=script&lang=js"
import style0 from "./personal-data.vue?vue&type=style&index=0&id=81aa0f3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa0f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81aa0f3a')) {
      api.createRecord('81aa0f3a', component.options)
    } else {
      api.reload('81aa0f3a', component.options)
    }
    module.hot.accept("./personal-data.vue?vue&type=template&id=81aa0f3a&scoped=true", function () {
      api.rerender('81aa0f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/personal-data.vue"
export default component.exports